import api from "../../api"
import { adapterSocialMedia } from "../../utils";
import { subAdapter as singleSubAdapter } from '../organization/adapter'

const subAdapter = {
  partner: {
    external: {
      formToRequestBody(input){
        let output = {}

        if(input){
          const {
            name,
            website,
            // logo
          } = input

          output = {
            namaPartner: name,
            websitePartner: website,
          };
        }

        return output
      }
    }
  }
}

const adapter = {
  responseBodyToForm(input){
    let output = {}

    // default file path from backend
    const defaultBinInstitutionProfile = '/assets/file.pdf'

    if(input){
      const {
        // About
        organisasiId,
        namaOrganisasi,
        tahunBerdiri,
        imgLogoOrganisasi,
        imgMainImage,
        deskripsi,
        highlight,
        typeApproach = [],
        typeAudience = [],
        typeIssues = [],
        typeOrganisasi = [],
        binInstitutionProfile,
        tampilan,

        // Contact & Location
        emailOrganisasi,
        teleponOrganisasi,
        lokasiOrganisasi = [],

        // Milestones
        milestoneOrganisasi = [],

        // Partners
        partnerOrganisasiInternal = [],
        partnerOrganisasiEksternal = [],

        // Social Media
        sosialMedia = [],
        websiteOrganisasi
      } = input

      const approaches = typeApproach.map(a => {
        return {
          label: a.nama[0],
          value: a.id
        }
      })

      const issues = typeIssues.map(a => {
        return {
          label: a.nama[0],
          value: a.id
        }
      })

      const audiences = typeAudience.map(a => {
        return {
          label: a.nama[0],
          value: a.id
        }
      })

      const types = typeOrganisasi.map(a => {
        return {
          label: a.nama[0],
          value: a.id
        }
      })

      const firstLocation = lokasiOrganisasi[0]

      const province = firstLocation ?
        {
          label: firstLocation.provinsi,
          value: firstLocation.provinsi
        } : ''

      const city = firstLocation ?
        {
          label: firstLocation.kota,
          value: firstLocation.kota
        } : ''

      output = {
        id: organisasiId,

        // About
        name: namaOrganisasi,
        established_since: tahunBerdiri,
        logo: api.base_image+imgLogoOrganisasi,
        image: api.base_image+imgMainImage,
        background_color: tampilan,
        description_id: deskripsi?.[0],
        description_en: deskripsi?.[1],
        highlight_id: highlight === null ? '' : highlight?.[0],
        highlight_en: highlight === null ? '' : highlight?.[1],
        approaches_saved: approaches,
        approaches,
        issues_saved: issues,
        issues,
        audiences_saved: audiences,
        audiences,
        types_saved: types,
        types,
        company_profile: binInstitutionProfile === defaultBinInstitutionProfile ? null : api.base_image+binInstitutionProfile,

        // Contact & Location
        email: emailOrganisasi,
        phone: teleponOrganisasi,
        province,
        city,
        address: firstLocation ? firstLocation.jalan : '',
        pin_point: firstLocation ? firstLocation.pinLocation : '',
        location_id: firstLocation?.pkLokasiOrganisasiId,

        // Milestones
        milestones: milestoneOrganisasi.map(m => {
          return {
            id: m.pkMilestoneId,
            year: m.tahun,
            description_id: m.deskripsi[0],
            description_en: m.deskripsi[1]
          }
        }),

        // Partners
        partners: partnerOrganisasiInternal.map(p => singleSubAdapter.partner.responseBodyToRender(p)),
        partners_external: partnerOrganisasiEksternal.map(p => {
          return {
            pkId: p.pkPartnerEksternalId,
            id: p.systemRowId,
            name: p.namaPartner,
            image: api.base_image+p.imgLogoPartner,
            website: p.websitePartner
          }
        }),

        social_media: adapterSocialMedia.APIToForm(sosialMedia, {}),
        website: websiteOrganisasi
      }
    }

    return output
  },

  formToRequestBody(input, part){
    let output = {}

    if(input){
      if(part === 'about'){
        const {
          name,
          established_since,
          description_en,
          description_id,
          highlight_en,
          highlight_id,
          // approaches_saved,
          approaches,
          // issues_saved,
          issues,
          // audiences_saved,
          audiences,
          // types_saved,
          types,
          background_color,
        } = input

        // const approaches_saved_values = approaches_saved.map(a => a.value)
        // const issues_saved_values = issues_saved.map(a => a.value)
        // const audiences_saved_values = audiences_saved.map(a => a.value)
        // const types_saved_values = types_saved.map(a => a.value)
        // const uniqueApproaches = approaches.filter(a => !approaches_saved_values.includes(a.value))
        // const uniqueIssues = issues.filter(a => !issues_saved_values.includes(a.value))
        // const uniqueAudiences = audiences.filter(a => !audiences_saved_values.includes(a.value))
        // const uniqueTypes = types.filter(a => !types_saved_values.includes(a.value))

        const finalHighlight = {
          id: highlight_id ? highlight_id : 'N/A',
          en: highlight_en ? highlight_en : 'N/A',
        }

        const finalDescription = {
          id: description_id ? description_id : 'N/A',
          en: description_en ? description_en : 'N/A',
        }

        output = {
          namaOrganisasi: name,
          tahunBerdiri: established_since,
          deskripsi: [finalDescription.id, finalDescription.en],
          highlight: [finalHighlight.id, finalHighlight.en],
          // typeApproach: uniqueApproaches.map(a => a.value),
          // typeIssues: uniqueIssues.map(a => a.value),
          // typeAudience: uniqueAudiences.map(a => a.value),
          // typeOrganisasi: uniqueTypes.map(a => a.value),
          typeApproach: approaches.map(a => a.value),
          typeIssues: issues.map(a => a.value),
          typeAudience: audiences.map(a => a.value),
          typeOrganisasi: types.map(a => a.value),
          tampilan: background_color,
        }
      }

      if(part === 'contact'){
        const {
          email,
          phone,
          website
        } = input

        output = {
          emailOrganisasi: email,
          teleponOrganisasi: phone,
          websiteOrganisasi: website
        }
      }

      if(part === 'location'){
        const {
          address,
          pin_point,
          province = {},
          city,
        } = input

        const finalCity = city && typeof city === 'string' ? city
          : city && city.value ? city.value
          : null

        output = {
          provinsi: province.value,
          kota: finalCity,
          jalan: address,
          pinLocation: pin_point,
          typeVisibility: 1
        }
      }

      if(part === 'milestones'){
        const { milestones } = input

        let result = []
        if (milestones && milestones.length > 0) {
          for (let index = 0; index < milestones.length; index++) {
            const milestone = milestones[index];
            if(milestone.id){
              result.push({
                tahun: milestone.year,
                deskripsi: [
                  milestone.description_id,
                  milestone.description_en
                ],
                pkMilestoneId: milestone.id
              })
            } else {
              result.push({
                tahun: milestone.year,
                deskripsi: [
                  milestone.description_id,
                  milestone.description_en
                ]
              })
            }
          }
        }

        output = {
          milestoneOrganisasi: result
        }
      }

      if(part === 'partners'){
        const { partners } = input

        let result = []
        if(partners && partners.length > 0){
          for (let index = 0; index < partners.length; index++) {
            const partner = partners[index];
            // result.push({
            //   partner: partner.id
            // })
            result.push(partner.id)
          }
        }

        output = {
          partnerOrganisasiInternal: result
        }
      }
    }

    return output
  }
}

export { subAdapter }
export default adapter
